import React, { ReactNode } from "react";
import { Box, Container } from "@mui/material";

interface MobileContainerProps {
    children: ReactNode;
    footer?: ReactNode;
    centerContent?: boolean;
}

const MobileContainer: React.FC<MobileContainerProps> = ({
                                                             children,
                                                             footer,
                                                             centerContent = false,
                                                         }) => {
    return (
        <Container
            maxWidth="sm"
            disableGutters
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: centerContent ? "space-between" : "flex-start",
                alignItems: centerContent ? "center" : "stretch",
                pt: 4,
                pb: 2,
                px: 2,
                backgroundColor: "#f9f9f9",
            }}
        >
            {centerContent && <Box />}

            <Box textAlign={centerContent ? "center" : "left"} width="100%">
                {children}
            </Box>

            {footer && <Box width="100%">{footer}</Box>}
        </Container>
    );
};

export default MobileContainer;
